export const HARDCODED_PROJECT_ID = 11;

export const SEGMENT_CARD_COLORS = ['#28aae1', '#565add', '#1D94C7', '#7b7bc7', '#76d1ff', '#b3b5e8', '#4CB847'];

/**
 * Digital-twin chat greeting/starter questions used when a segment has no saved chat config
 * (`initialMessage` / `questions` are `null`). Shared so the segment profile's "Customize Chat
 * Questions" section shows exactly what the chat itself will use.
 */
export const DEFAULT_SEGMENT_INITIAL_MESSAGE =
  "Hi, I'm a digital twin of this HCP segment. I can help you understand how this segment thinks, what evidence matters most, and how they may respond to different messages. Ask me anything!";

export const DEFAULT_SEGMENT_QUESTIONS: readonly string[] = [
  'What are the top clinical priorities for this segment?',
  'How does this segment typically evaluate new treatment options?',
  'What types of evidence would resonate most with this segment?',
  'What are the most likely objections from this segment to our message?',
];
